import { Injectable, Injector } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from '../services/app-config.service';
import { ErrorHandlerService } from '../services/error-handler.service';
import { PagingResponse } from '@models/paging-response.model';
import { FolderResource } from '../models/resource/folder.resource';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { ODataRequest } from '../utilities/sdk-base/o-data-request';
import { Folder } from '../models/ui/folder.model';

@Injectable({
	providedIn: 'root'
})
export class FolderSdk extends SdkBase {

	constructor(private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService, injector: Injector) {
		super(injector);
	}

	public getFolder$(folderId: string): Observable<FolderResource> {
		return this.httpClient.get<FolderResource>(`${this.appConfigService.getConfig().webApi }/api2/folders/${ folderId }`)
			.pipe(catchError(this.errorHandler.handleError<FolderResource>(`get folders/key`)));
	}

	public getRootFolder(): Observable<PagingResponse<FolderResource>> {
		return this.httpClient.get<PagingResponse<FolderResource>>(`${this.appConfigService.getConfig().webApi }/api2/folders?$filter=isCaseRootNode eq true`)
			.pipe(catchError(this.errorHandler.handleError<PagingResponse<FolderResource>>(`get folders`)));
	}

	public getChildrenOf(parentId: string): Observable<PagingResponse<FolderResource>> {
		return this.httpClient.get<PagingResponse<FolderResource>>(`${this.appConfigService.getConfig().webApi }/api2/folders?$filter=parentFolderId eq ${ parentId }&$orderby=folderName`)
			.pipe(catchError(this.errorHandler.handleError<PagingResponse<FolderResource>>(`get child folders`)));
	}

	public getDocCount(folderId: string): Observable<number> {
		return this.httpClient.get<number>(`${this.appConfigService.getConfig().webApi }/api2/folders/${ folderId }/doccount`)
			.pipe(catchError(this.errorHandler.handleError<number>(`get folder doc count`)));
	}

	public post(folder: Folder): Observable<void> {
		if(!folder?.parentFolderId) of(null);

		const request = new ODataRequest('post', 'folders', folder);
		return this.makeODataRequest$<void>(request, 'api2');
	}

	public put(folder: Folder): Observable<void> {
		if(!folder?.folderId) of(null);

		const request = new ODataRequest('put', 'folders', folder.folderId, folder);
		return this.makeODataRequest$<void>(request, 'api2');
	}

	public delete(folder: Folder): Observable<void> {
		if(!folder?.folderId) return of(null);

		const request = new ODataRequest('delete', 'folders', folder.folderId);
		return this.makeODataRequest$<void>(request, 'api2');
	}

	public import(caseId: string): Observable<void> {
		if(!caseId) return of(null);

		return this.makeHttpRequest('post', 'api2/import/folders', { fromCaseId: caseId });
	}
}
